/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var Severity;
(function (Severity) {
    Severity["Debug"] = "DEBUG";
    Severity["Info"] = "INFO";
    Severity["Warning"] = "WARNING";
    Severity["Error"] = "ERROR";
})(Severity || (Severity = {}));
export function SeverityFromJSON(json) {
    return SeverityFromJSONTyped(json, false);
}
export function SeverityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SeverityToJSON(value) {
    return value;
}
